<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Schedule PT Appointment</div>
        <div class="box-mini mb-10">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-7">
              </div>
              <div class="col-sm-5 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" class="table-fixedwidth text-center">
              <template v-slot:cell(receipt_date)="data">
<!--              <template slot="receipt_date" slot-scope="data">-->
                {{dateFormat(data.item.receipt_date)}}
              </template>
              <template v-slot:cell(member)="data">
                  {{data.item.member.first_name}} {{data.item.member.last_name}}
              </template>
              <template v-slot:cell(action)="data">
<!--              <template slot="action" slot-scope="data">-->
                <!-- <b-button size="sm" @click="openPage('/settlement/edit?id=' + data.item.id)" class="btn-table warning mr-5">
                  <i class="fas fa-pen font-12 mr-5"></i>Edit
                </b-button> -->
                <b-button size="sm" @click="cancel(data.item)" class="btn-table green">
                  <i class="fas fa-ban font-12 mr-5"></i>Cancel
                </b-button>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'schedulePtAppointment',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      fields: [
        {
          key: 'class_date',
          label: 'Class Date',
          sortable: true
        },
        {
          key: 'time_start',
          label: 'Class Time',
          sortable: false
        },
        {
          key: 'classes_schedule.class.name',
          label: 'Class Name',
          sortable: false
        },
        {
          key: 'member',
          label: 'Member',
          sortable: false
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false
        }
      ],
      dateWeek: '',
      items: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      dateString: '27-07-1993'
    }
  },
  methods: {
    cancel(item) {
      // console.log(item.id)
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Cancel it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          axios.delete('fitness/v1/booking/cancel/' + item.id).then(response => {
            this.$swal('Session Canceled', 'You successfully cancel this Session!', 'success')
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    dateFormat (value) {
      return moment(new Date(value)).format('DD MMM YYYY')
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    ifPaymentNull (value) {
      var data = value
      var replaceValue = ''
      if (data === null) {
        replaceValue = ''
      }
      else {
        replaceValue = data.name
      }
      return replaceValue
    },
    fetchData() {
      // axios.get('crm/v1/sales_report/guest_register').then(response => {
      axios.get('fitness/v1/member/crm/member/my_class?pt_id='+ Auth.Session.get().paradigm_id +'&limit='+this.paginationLimit+'&page=' + this.currentPage + '&keyword=' + this.searchData).then(response => {
        console.log(response)
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log(this.items)
        //console.log('test', response.data.data)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
